module.exports = __webpack_public_path__ + "static/media/rundkolben_loesung.848cb8f6.jpg";